import { DocumentCategoryMetric } from 'features/libra/stepComponents/niiDataHealth/useDataHealthMetrics'
import { GeckoFileCategory, GeckoFileCategoryLabels, GeckoReport } from 'types'

/**
 * Computes document category metrics from a list of reports.
 * Groups reports by their file category and counts them.
 * Returns metrics sorted alphabetically by category label.
 */
export function computeCategoryMetrics(
  reports: ReadonlyArray<GeckoReport>
): ReadonlyArray<DocumentCategoryMetric> {
  const categoryMap = new Map<GeckoFileCategory, Set<string>>()

  reports.forEach((report: GeckoReport) => {
    const category = report.data.file_category ?? GeckoFileCategory.UNKNOWN
    if (!categoryMap.has(category)) {
      categoryMap.set(category, new Set())
    }
    categoryMap.get(category)!.add(report.id)
  })

  const metrics: ReadonlyArray<DocumentCategoryMetric> = Array.from(
    categoryMap.entries(),
    ([category, reportIds]) => ({
      category,
      categoryLabel: GeckoFileCategoryLabels[category] || category,
      count: reportIds.size,
      reportIds: Array.from(reportIds) as ReadonlyArray<string>,
    })
  )

  return metrics.toSorted((a, b) =>
    a.categoryLabel.localeCompare(b.categoryLabel)
  )
}

/**
 * Calculates the total number of documents from category metrics.
 */
export function calculateTotalDocuments(
  categoryMetrics: ReadonlyArray<DocumentCategoryMetric>
): number {
  return categoryMetrics.reduce((sum, metric) => sum + metric.count, 0)
}
